export default __webpack_public_path__ + "static/media/packagebanner.42d5ed99.webp";